import React, { memo, useMemo } from "react"

export const RenderItemContent = memo(function RenderItemContent({ data, item, pass, index, keyFn }) {
    const props = useMemo(buildProps, [pass, item.props, index, data])
    const key = useMemo(getItemKey, [data, index, keyFn])

    return React.createElement(item.type, { key, ...props })

    function buildProps() {
        return { ...item.props, [pass]: data, index }
    }

    function getItemKey() {
        return data ? keyFn(data) ?? index : index
    }
}, haveEqualContentProps)

function haveEqualContentProps(previous, next) {
    return (
        previous.data === next.data &&
        previous.pass === next.pass &&
        previous.index === next.index &&
        previous.keyFn === next.keyFn &&
        haveEqualItems(previous.item, next.item)
    )
}

function haveEqualItems(previous, next) {
    if (previous === next) return true
    if (!previous || !next) return false
    return previous.type === next.type && haveEqualObjectValues(previous.props, next.props)
}

function haveEqualObjectValues(previous = {}, next = {}) {
    const previousKeys = Object.keys(previous)
    const nextKeys = Object.keys(next)
    if (previousKeys.length !== nextKeys.length) return false

    return previousKeys.every(hasMatchingValue)

    function hasMatchingValue(key) {
        return previous[key] === next[key]
    }
}
